<template>
  <div>
    <template v-if="isLoading || value === undefined">
      <span class="icon">
        <i class="fas fa-spinner fa-pulse"></i>
      </span>
    </template>
    <template v-else-if="isEditting">
      <div class="field">
        <div class="control">
          <input type="text"
              class="input"
              v-bind:value="value"
              v-on:input="$emit('input', $event.target.value)"
              :disabled="isSaving"
              :class="isInvalidInternal ? 'is-danger' : ''">
        </div>
      </div>
    </template>
    <template v-else>
      <slot>{{value}}</slot>
    </template>
  </div>
</template>
<script>
export default {
  name: 'EditableInput',
  props: ['value' ,'isLoading', 'isEditting', 'isSaving', 'isInvalid'],
  computed: {
    isInvalidInternal() {
      return this.isInvalid || !this.value;
    }
  },
}
</script>